/**
 * BACKFLIP BREAKFAST — Theme JavaScript
 * Scroll reveals, mobile menu, sparkle effects
 * Lightweight: no dependencies, vanilla JS only
 */

(function () {
  'use strict';

  /* ==========================================================================
     Scroll Reveal (Intersection Observer)
     ========================================================================== */

  function initScrollReveal() {
    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal-up, .reveal-left, .reveal-right').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    document.querySelectorAll('.reveal-up, .reveal-left, .reveal-right').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ==========================================================================
     Mobile Menu
     ========================================================================== */

  function initMobileMenu() {
    var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (!toggleBtn || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', openMenu);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    // Close on link click
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /* ==========================================================================
     Smooth Scroll for anchor links
     ========================================================================== */

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.site-header')
            ? document.querySelector('.site-header').offsetHeight
            : 0;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  /* ==========================================================================
     Sticky Header Shadow
     ========================================================================== */

  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrolled = false;

    function onScroll() {
      if (window.scrollY > 10) {
        if (!scrolled) {
          header.style.boxShadow = '0 4px 20px rgba(30, 22, 64, 0.3)';
          scrolled = true;
        }
      } else {
        if (scrolled) {
          header.style.boxShadow = 'none';
          scrolled = false;
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ==========================================================================
     Sparkle Effect on Hover (flavor cards)
     ========================================================================== */

  function initSparkleEffect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.flavor-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        createSparkle(card);
      });
    });
  }

  function createSparkle(parent) {
    var sparkle = document.createElement('span');
    sparkle.className = 'sparkle-effect';
    sparkle.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="#FFD700"><path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z"/></svg>';
    sparkle.style.cssText =
      'position:absolute;top:' +
      Math.random() * 80 +
      '%;left:' +
      Math.random() * 80 +
      '%;pointer-events:none;z-index:10;animation:sparkle 0.6s ease-out forwards;';
    parent.appendChild(sparkle);
    setTimeout(function () {
      sparkle.remove();
    }, 600);
  }

  /* ==========================================================================
     Email Form (basic client-side handling)
     ========================================================================== */

  function initEmailForms() {
    document.querySelectorAll('[data-klaviyo-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button[type="submit"]');

        if (!emailInput || !emailInput.value) return;

        var email = emailInput.value;
        var listId = form.getAttribute('data-klaviyo-list');

        // If Klaviyo JS is loaded, use it
        if (window._klOnsite) {
          // Klaviyo integration would go here
          console.log('Klaviyo subscribe:', email, 'List:', listId);
        }

        // Visual feedback
        var originalText = submitBtn.textContent;
        submitBtn.textContent = '✨ You\'re In!';
        submitBtn.disabled = true;
        emailInput.value = '';

        setTimeout(function () {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 3000);
      });
    });
  }

  /* ==========================================================================
     Init
     ========================================================================== */

  function init() {
    initScrollReveal();
    initMobileMenu();
    initSmoothScroll();
    initHeaderScroll();
    initSparkleEffect();
    initEmailForms();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
